const fragment = `
  id
  name
  description
  imageUrl
  basePrice  
  lastModifiedLog {
    id
    initialValue
    finalValue
    maker {
      id
      name
      role
    }
  }
  creator {
    id
    name
    role
  }
`;

export const listPackagesQuery = `
  query ListPackages(
    $filter: PackageFilterInput
  ) {
    items: listPackages(filter: $filter) {
      ${fragment}
    }
  }
`;

export const getPackageQuery = `
  query GetPackage($id: Int!) {
    item: getPackage(id: $id) {
      ${fragment}
    }
  }
`;

export const createPackageQuery = `
  mutation CreatePackage(
    $input: CreatePackageInput!
    $image: Upload
  ) {
    item: createPackage(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const updatePackageQuery = `
  mutation UpdatePackage(
    $input: UpdatePackageInput!,
    $image: Upload
  ) {
    item: updatePackage(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const deletePackageQuery = `
  mutation DeletePackage(
    $id: Int!
  ) {
    item: deletePackage(id: $id) {
      ${fragment}
    }
  }
`;
